<template>
    <div>
        <v-dialog v-model="showInvoiceModal" @close="close"
                  fullscreen
                  hide-overlay
                  transition="dialog-bottom-transition"
                  scrollable
        >
            <v-card tile>
                <v-toolbar class="blue-grey darken-2 white--text" height="55px" card dark>
                    <v-btn icon dark @click="close">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{getDocumentName}} {{selectedInvoice.code ? getInvoiceCode() : 'programada'}}</v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-chip v-if="isInvoiceCanceled" ma-3 label outline color="red">Anulado</v-chip>
                    <div v-else>
                        <span v-if="selectedInvoice.pendent_value > 0">
                            <span  class="green--text text--lighten-3"><b>Pago: {{getAlreadyPaid | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</b></span>
                            <br><span>Pendente: {{selectedInvoice.pendent_value | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</span>
                        </span>
                        <v-chip v-else ma-3 label outline color="light-green lighten-2">Pago</v-chip>
                    </div>
                    <!--<v-layout row wrap color="success">-->
                        <!--<v-flex xs6>Pago</v-flex>-->
                        <!--<v-flex xs6>Por pagar</v-flex>-->
                    <!--</v-layout>-->
                </v-toolbar>

                <v-card-text>
                    <v-container fluid grid-list-md>
                        <v-layout row wrap justify-center>
                            <v-flex xs12 sm12 md8 justify-center>

                                <!--Motivo anulamento fatura-->
                                <v-flex xs12 v-if="!loadingExtraInvoiceInfos && isInvoiceCanceled">
                                    <v-card style="background-color: #fafafa">
                                        <v-card-title>
                                            <span style="font-weight: bold; font-size: 14px">Motivo anulamento: </span> 
                                            <span style="margin-left: 10px">{{selectedInvoice.cancel_reason ? selectedInvoice.cancel_reason : 'Não especificado'}}</span>
                                        </v-card-title>

                                    </v-card>
                                </v-flex>

                                <!-- Invoice Page -->
                                <v-flex xs12>
                                        <v-progress-linear
                                                color="indigo"
                                                v-if="loadingExtraInvoiceInfos"
                                                :indeterminate=true
                                                height="2"
                                                value="15"
                                        ></v-progress-linear>

                                        
                                        <div ref="factura">
                                            <div v-for="(fracturedSellLine, index) in fracturedSellLines.length">
                                                <invoice-page v-if="extraInfosLoaded" 
                                                    :fetchedInvoice="fetchedInvoice"
                                                    :sellLines="fracturedSellLines[index]"
                                                    :currentPage="index+1"
                                                    :totalPage="fracturedSellLines.length"
                                                    :total="total"
                                                    :invoicePrintLabel="invoicePrintLabel"
                                                    :isInvoiceCanceled="isInvoiceCanceled"
                                                    :isInvoiceA5Format="isInvoiceA5Format"
                                                ></invoice-page>
                                            </div>
                                        </div>
                                        

                                        
                                </v-flex>

                                
                                <!--Receipt Container-->
                                <v-flex xs12 v-if="!loadingExtraInvoiceInfos" >
                                    <ReceiptContainer mt-4 xs12 
                                        :receipts="receipts"
                                        :deletedReceipts="deletedReceipts"
                                        :isA5Format="isReceiptA5Format"
                                    ></ReceiptContainer>
                                </v-flex>
                                
                            </v-flex>

                            <!--Side Buttons-->
                            <v-flex xs12 sm12 md3 lg2 style="margin-top: 25px">
                                <v-flex mx-2 xs12>
                                    <v-btn :disabled="!extraInfosLoaded || !selectedInvoice.code || isInvoiceCanceled || selectedInvoice.shelved===1
                                                || selectedInvoice.pendent_value <= 0"
                                               block mx-2 grow color="success" @click="openPayment">Pagamento/Recibo</v-btn>
                                    </v-flex>
                                    <v-flex mx-2 xs12>
                                        <v-btn :disabled="!extraInfosLoaded || !selectedInvoice.code" block
                                               :loading="downloadingOriginal"
                                                class="white--text" mx-2 grow color="indigo lighten-2" @click="downloadPDF(DOWNLOAD_ORIGINAL)">Baixar Original</v-btn>
                                    </v-flex>
                                    <v-flex mx-2 xs12>
                                        <v-btn :disabled="!extraInfosLoaded || !selectedInvoice.code" block
                                               :loading="downloading2via"
                                               class="white--text" mx-2 grow color="indigo lighten-3" @click="downloadPDF(DOWNLOAD_2VIA)">Baixar 2ª via</v-btn>
                                    </v-flex>
                                    <v-flex mx-2 xs12>
                                        <v-btn :disabled="!extraInfosLoaded || shelving || !selectedInvoice.code || isInvoiceCanceled"
                                               :loading="shelving"
                                               block
                                               class="white--text" mx-2 grow color="blue-grey lighten-3" @click="shelve">{{selectedInvoice.shelved ? 'Desarquivar' : 'Arquivar'}}</v-btn>
                                    </v-flex>

                                    <v-flex mx-2 mt-4 xs12>
                                        <v-btn :disabled="!extraInfosLoaded || isInvoiceCanceled" block class="white--text" mx-2 grow color="red" @click="askCancel">{{isInvoiceCanceled ? 'Anulado' : 'Anular'}}</v-btn>
                                    </v-flex>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>

            <!--Add payment-->
            <add-payment
                    :paymentMethods="paymentMethods"
                    :invoiceId="selectedInvoice.id"
                    :pendentValue="selectedInvoice.pendent_value ? selectedInvoice.pendent_value : 0"
                    :isProntoPagamento="false"
            ></add-payment>

            <!--Credit Debit-->
            <credit-debit-note
                    :articles="articles">
            </credit-debit-note>

            <!--Confirmation Dialog for trashing receipt-->
            <v-dialog persistent max-width="400" v-model="openConfirmationDialog" @close="closeConfirmation">
                <v-card>
                    <!--<v-card-title class="headline">Use Google's location service?</v-card-title>-->
                    <v-card-text class="text-xs-center">
                        <p>Tens a certeza que queres anular o recibo <b>{{selectedReceiptCode+'/'+selectedReceiptSeries}}</b>?</p>
                        <v-flex>
                            <v-textarea
                                    v-model="trashReceiptReason"
                                    rows=2
                                    label="Observação*"
                                    hint="Obrigatório"
                                    persistent-hint
                            ></v-textarea>
                        </v-flex>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <div v-if="!loading_delete_receipt">
                            <v-btn color="red darken-1" flat :disabled="!trashReceiptReason" @click="trashReceipt(MULTI_INVOICE_PER_RECEIPT_FIRST_TURN)">Sim</v-btn>
                            <v-btn color="grey darken-1" flat @click="closeConfirmation">Não</v-btn>
                        </div>
                        <v-progress-circular v-else indeterminate color="primary" m-2 ></v-progress-circular>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <!--Confirmation deleting receipt that belogns to multiple invoice-->
            <v-dialog persistent max-width="500" v-model="openConfirmationDialogMultiInvoicePerReceipt" @close="openConfirmationDialogMultiInvoicePerReceipt = false">
                <v-card>
                    <!--<v-card-title class="headline">Use Google's location service?</v-card-title>-->
                    <v-card-text class="text-xs-center">
                        <p><span class="red--text text--lighten-1">Cuidado! </span>Este recibo encontra-se associada a mais de uma fatura.
                            Sua eliminação, resultará na alteração do <span class="blue--text text--darken-2">valor pendente</span> de cada fatura em que se encontra associada.</p>
                        <p class="text-xs-center">Deseja eliminar essa fatura mesmo assim?</p>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <div v-if="!loading_delete_receipt">
                            <v-btn color="red darken-1" flat @click="trashReceipt(MULTI_INVOICE_PER_RECEIPT_SECOND_TURN)">Sim</v-btn>
                            <v-btn color="grey darken-1" flat @click="openConfirmationDialogMultiInvoicePerReceipt = false">Não</v-btn>
                        </div>
                        <v-progress-circular v-else indeterminate color="primary" m-2 ></v-progress-circular>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <!--Cancel Invoice-->
            <v-dialog persistent max-width="500" v-model="invoiceCancelModal" @close="invoiceCancelModal = false">
                <v-card>
                    <!--<v-card-title class="headline">Use Google's location service?</v-card-title>-->
                    <v-card-text class="text-xs-center">
                        <p><span class="red--text text--lighten-1">Cuidado! Esta ação não poderá ser revertida.</span></p>
                        <p style="margin-top: -10px; margin-bottom: 10px" class="text-xs-center">Deseja anular esta fatura mesmo assim?</p>
                        <v-flex>
                            <v-textarea
                                    v-model="cancel_reason"
                                    outline
                                    rows=3
                                    label="Motivo do cancelamento"
                                    hint="Obrigatório"
                                    persistent-hint
                            ></v-textarea>
                        </v-flex>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <div v-if="!loading_cancel_invoice">
                            <v-btn color="red darken-1" :disabled="!cancel_reason" flat @click="cancelInvoice()">Sim</v-btn>
                            <v-btn color="grey darken-1" flat @click="invoiceCancelModal = false">Não</v-btn>
                        </div>
                        <v-progress-circular v-else indeterminate color="primary" m-2 ></v-progress-circular>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-dialog>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Types} from "../../config";
    import ReceiptContainer from '../receipt/ReceiptContainer';
    import AddPayment from '../receipt/AddPayment';
    import InvoicePage from './InvoicePaper/InvoicePage.vue';
    import html2pdf from "html2pdf.js";
    import {mapGetters} from "vuex";
    import {eventBus} from "../../main";

    export default {
        name: 'invoice_form_modal',
        created () {
            let vm = this;
            // this.onFormModalOpened(vm);
            this.thrashReceiptEvent(vm);
            this.receiptAdded(vm);
        },

        beforeDestroy(){
            eventBus.$off('onInvoiceFormOpened');
            eventBus.$off('onTrashingReceipt');
            eventBus.$off('onReceiptSave');
        },

        data(){
            return {
                // testArray: ['Page1'],
                testArray: ['Page1', 'Page2', 'Page3', 'Page4', 'Page5'],

                Types,
                MULTI_INVOICE_PER_RECEIPT_FIRST_TURN: 1,  //constant
                MULTI_INVOICE_PER_RECEIPT_SECOND_TURN: 2, //constant
                DOWNLOAD_ORIGINAL: 1,
                DOWNLOAD_2VIA: 2,

                loadingExtraInvoiceInfos: false,
                extraInfosLoaded: false,
                openConfirmationDialog: false,
                openConfirmationDialogMultiInvoicePerReceipt: false,
                loading_delete_receipt: false,
                loading_cancel_invoice: false,
                shelving: false,
                sendingMail: false,
                currency: '',
                taxPercentage: '?',
                totalDiscount: 0,
                taxMoney: 0,
                total: 0,
                sellTotalValue: 0,
                invoicePrintLabel: 'Original',
                openCreditDebitLoading: false,
                downloadingOriginal: false,
                downloading2via: false,

                companyLogBase64: '',

                selectedReceiptId: '',
                selectedReceiptCode: '',
                selectedReceiptSeries: '',

                sellLines: [],
                fracturedSellLines: [],
                payments: [],
                receipts: [],
                deletedReceipts: [],
                receiptInvoices: [],
                articles: [],

                trashReceiptReason: '',
                cancel_reason: '',
                invoiceCancelModal: false,

                //settings
                isInvoiceA5Format: false,
                isReceiptA5Format: false,

            }
        },

        props:[
            'paymentMethods'
        ],

        watch: {
            showInvoiceModal(){
                this.onFormModalOpened();
            }
        },

        computed:{
            ...mapGetters([
                'loggedUser',
                'getToken',
            ]),
            showInvoiceModal: {
                get(){ return this.$store.getters.getShowInvoiceModal; },
                set(value){ this.$store.dispatch('setShowInvoiceModal', value); }
            },
            showPaymentModal: {
                get(){ return this.$store.getters.getShowPaymentModal; },
                set(value){ this.$store.dispatch('setShowPaymentModal', value); }
            },

            selectedInvoice: {
                get(){ return this.$store.getters.getSelectedInvoice; },
                set(value){ this.$store.dispatch('setSelectedInvoice', value); }
            },

            showCreditDebitModal: {
                get(){ return this.$store.getters.setShowCreditDebitModal; },
                set(value){ this.$store.dispatch('setShowCreditDebitModal', value); }
            },


            getAlreadyPaid(){
                // this.consoleLog("newGetAlreadyPaid: "+ (this.selectedInvoice.total_value - this.selectedInvoice.pendent_value));
                return this.selectedInvoice.total_value - this.selectedInvoice.pendent_value;
            },

            getDocumentName(){
                switch (this.selectedInvoice.types_document_id) {
                    case Types.document_type.FACTURA:
                        return "Fatura";
                    case Types.document_type.FACTURA_RECIBO:
                        return "Fatura/Recibo";
                    default:
                        return "";
                }
            },

            

            getSubTotal(){
                let mSubtotal = 0;

                for(let i=0; i<this.sellLines.length; i++){
                    let sellLine = this.sellLines[i];
                    let soldQuantity = sellLine.sold_quantity ? sellLine.sold_quantity : 0;
                    let quantityToBeDelivered = !sellLine.quantity_to_be_delivery ? 0 : sellLine.quantity_to_be_delivery;

                    let subtotalNoDiscount = sellLine.sell_price * (soldQuantity);
                    mSubtotal += subtotalNoDiscount;

                }

                return mSubtotal;
            },

            getFileName(){
                return 'Fatura_'+this.fetchedInvoice.code+''+this.fetchedInvoice.series+'.pdf'
            },

            isInvoiceCanceled(){
                return this.selectedInvoice.types_operation_type_id === Types.operation_type.ANULADO;
            },

            getSellLines(){
                return this.sellLines;
                // return this.getSellLinesTesting;
            },
            
            //used for testing purpouse, to check when invoice has many sellLines
            getSellLinesTesting(){
                let mArray = [];
                // this.consoleLog('sellLines: ', this.sellLines);
                
                for(let i = 0; i <= 3; i++){
                    let sellLineCopy = JSON.parse(JSON.stringify(this.sellLines[0]));
                    if(sellLineCopy && sellLineCopy.article) sellLineCopy.article.name = 'Item '+(i+1)+ ' a realllyyyy loonng tenxt, for testing purpouse only nothing, no reason to spcificaly make a huge line like this. Hmm just a moment, maybe this sentence is not that long as we uspected before, maybe it could be increase just  a litle bit more.';
                    mArray.push(sellLineCopy);
                }
                // this.consoleLog('sellLinesTEESST: ', mArray);
                return mArray;
            },
        },

        components: {
            ReceiptContainer,
            AddPayment,
            InvoicePage
        },

        methods:{

            //divides the fetched selll lines and divide them in small arrays, one for each invoice page, for pdf file printing
            setUpFracturedSellLines(){
                const a4_maxLine = 14;
                const a5_maxLine = 6;
                let maxLine = this.isInvoiceA5Format ? a5_maxLine : a4_maxLine;

                if(!this.getSellLines) return [];

                let cont = 1, mArrayIndex = 0;
                let inArray = [];
                let totalLength = this.getSellLines.length
                for(let i=0; i < totalLength; i++){

                    inArray.push(this.getSellLines[i]);

                    if(cont > maxLine || i == totalLength-1){
                        this.fracturedSellLines[mArrayIndex] = inArray;
                        mArrayIndex++;
                        cont = 1;
                        inArray = [];
                    }else{
                        cont++;
                    }

                }
                // this.consoleLog('getFracturedSellLines: ', this.fracturedSellLines);

            },
            save(){

                this.close();
            },
            close(){
                this.consoleLog('close invoice formModal');
                this.showInvoiceModal = false;
            },
            closeConfirmation(){
                this.openConfirmationDialog = false;
                this.loading_delete_receipt = false;
                this.trashReceiptReason = '';
                this.selectedReceiptId = '';
            },

            getClientName(){
                try{
                    // this.consoleLog('client: '+this.fetchedInvoice.sell.client.name);
                    return this.fetchedInvoice.sell.client.name;
                }catch (e) { console.log(e);return "";}
            },

            getClientNif(){
                try {
                    // this.consoleLog('nif: '+this.fetchedInvoice.sell.client.nif);
                    return this.fetchedInvoice.sell.client.nif;
                }catch (e) { return 'indefinido'; }
            },

            getClientPhone(){
                return this.getPhone(JSON.parse(this.fetchedInvoice.sell.client.contacts_json));
            },

            getClientEmail(){
                try{
                    let json = JSON.parse(this.fetchedInvoice.sell.client.contacts_json);
                    return json[0].email;
                }catch (e) { return ""}
            },

            getTrashedReceipts(fetchedReceipts){
                let retTeceipts = [];
                fetchedReceipts.forEach(receiptIt => {
                    if(receiptIt.deleted_at){
                        retTeceipts.push(receiptIt);
                    }
                });
                return retTeceipts;
            },

            getNonTrashedReceipts(fetchedReceipts){
                let retTeceipts = [];
                fetchedReceipts.forEach(receiptIt => {
                    if(!receiptIt.deleted_at){
                        retTeceipts.push(receiptIt);
                    }
                });
                return retTeceipts;
            },

            loadExtraInfos(){
                this.loadingExtraInvoiceInfos = true;
                Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                Vue.axios.get('invoice/'+this.selectedInvoice.id)
                    .then(response=>{
                        this.consoleLog('loadExtraInfos', response);
                        if (!response.data.success) {
                            this.handleErrorCodeMessage(response.data);
                            return;
                        }
                        this.extraInfosLoaded = true;
                        this.fetchedInvoice = response.data.response.invoice;
                        this.sellLines = this.fetchedInvoice.sell.sell_lines;
                        this.payments = this.fetchedInvoice.payments;
                        this.currency = this.fetchedInvoice.sell.type_currency.name;
                        this.taxPercentage = this.fetchedInvoice.sell.sell_tax;
                        this.total = this.fetchedInvoice.total_value;
                        this.sellTotalValue = this.fetchedInvoice.sell.total_value;
                        this.receipts = this.getNonTrashedReceipts(this.fetchedInvoice.receipts) || [];
                        this.deletedReceipts = this.getTrashedReceipts(this.fetchedInvoice.receipts) || [];
                        this.receiptInvoices = this.fetchedInvoice.receiptInvoices;

                        this.companyLogBase64 = response.data.response.base64logo;

                        let settings = response.data.response.invoice.sell.company.settings;

                        this.setSettings(settings);
                        this.setUpFracturedSellLines();

                    }).catch(error=>{
                        //Do nothing
                }).finally(()=>{
                    this.loadingExtraInvoiceInfos = false;
                });
            },

            setSettings(settings){
                if (settings.length > 0){
                    this.isInvoiceA5Format = settings[0].invoice_format === "A5";
                    this.isReceiptA5Format = settings[0].receipt_format === "A5";

                    // if(settings[0].invoice_format === "A5"){
                    //     this.isInvoiceA5Format = true;
                    // }

                }
            },

            getInvoiceCode(){
                return this.selectedInvoice.code + '/' + this.selectedInvoice.series;
            },

            getPhone(json){
                let mobile_phone = '', phone = '';
                try{
                    mobile_phone = json[0].mobile_phone;
                    phone = json[0].phone;

                    if(phone === null) phone = '';
                    if(mobile_phone === null) mobile_phone = '';
                }catch (e) {return ""}

                if(mobile_phone && phone)
                    return phone+" / "+mobile_phone;
                else if(!mobile_phone && !phone)
                    return '';
                else
                    return phone+""+mobile_phone;

            },

            onFormModalOpened(){
                if(!this.showInvoiceModal) return; //proceed only if the model was open, not closed

                this.consoleLog('onInvoiceFormModalOpened');
                this.fetchedInvoice = null;
                this.loadingExtraInvoiceInfos = true;
                this.extraInfosLoaded = false;

                this.loadExtraInfos();
            },

            thrashReceiptEvent(vm){
                eventBus.$on('onTrashingReceipt', function (id, code, series) {
                    vm.selectedReceiptId = id;
                    vm.selectedReceiptCode = code;
                    vm.selectedReceiptSeries = series;
                    vm.openConfirmationDialog = true;
                });
            },

            trashReceipt(turn){
                let canEraseSelectedReceiptId = false;
                this.loading_delete_receipt = true;
                Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                Vue.axios.post('receipt/trash', {
                    id: this.selectedReceiptId,
                    delete_reason: this.trashReceiptReason,
                }, { params : {t: turn}})
                    .then(response=>{
                        this.consoleLog(response);
                        this.consoleLog('ReceiptId: '+this.selectedReceiptId);
                        if(response.data.confirm === this.MULTI_INVOICE_PER_RECEIPT_FIRST_TURN){
                            this.openConfirmationDialogMultiInvoicePerReceipt = true;
                            return;
                        }
                        if(!response.data.success){
                            this.handleErrorCodeMessage(response.data);
                            return;
                        }

                        if(!this.receipts) return;
                        let receiptCodeToDelete = '';
                        for( let i = 0; i < this.receipts.length; i++){
                            if ( this.receipts[i] && this.receipts[i].id === this.selectedReceiptId) {
                                receiptCodeToDelete = this.receipts[i].code+'/'+this.receipts[i].series;
                                this.receipts.splice(i, 1);
                                break;
                            }
                        }

                        eventBus.$emit('onReceiptDeletedUpdateInvoice', response.data.response);


                        this.openConfirmationDialogMultiInvoicePerReceipt = false;
                        this.showSnackBar('Recibo ['+receiptCodeToDelete+'] eliminado com sucesso', 'success');
                        canEraseSelectedReceiptId = true;

                    }).catch(error=>{
                        this.showSnackBar('Erro ao eliminar recibo', 'error');
                        this.consoleLog(error);
                    }).finally(()=>{
                        if(canEraseSelectedReceiptId){
                            this.selectedReceiptId = '';
                            this.trashReceiptReason = '';
                        }
                        this.selectedReceiptCode = '';
                        this.selectedReceiptSeries = '';
                        this.loading_delete_receipt = false;
                        this.openConfirmationDialog = false;
                });
            },

            receiptAdded(vm){
                eventBus.$on('onReceiptSave', function (resp) {
                    vm.consoleLog(resp);
                    vm.consoleLog("newPendentValue: "+vm.selectedInvoice.pendent_value);
                    let receipt = resp.receipt;
                    if(receipt){
                        vm.selectedInvoice.pendent_value = resp.pendentValue;
                        vm.receipts.unshift(receipt);
                        vm.showSnackBar('Recibo ['+receipt.code+'] gerado com sucesso', 'success');
                    }else{
                        vm.showSnackBar('Erro ao gerar recibo', 'error');
                    }
                });
            },

            openPayment(){
                this.showPaymentModal = true;
            },

            askCancel(){
                this.invoiceCancelModal = true;
            },

            cancelInvoice(){
                try{
                    this.loading_cancel_invoice = true;
                    this.consoleLog('cancel Invoice: '+this.selectedInvoice.id);
                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.put('invoice/cancel/'+this.selectedInvoice.id, {
                        id: this.selectedInvoice.id,
                        cancel_reason: this.cancel_reason,
                    })
                        .then(response =>{
                            this.consoleLog('CancelInvoiceResponse: ', response);
                            if(!response.data.success){
                                this.handleErrorCodeMessage(response.data);
                                return;
                            }
                            let invoice = response.data.response.invoice;

                            this.close();
                            eventBus.$emit('onCancelingInvoice', invoice, 'Fatura');

                        }).catch(error => {
                        this.consoleLog(error);
                    }).finally(()=>{
                        this.loading_cancel_invoice = false;
                        this.invoiceCancelModal = false;
                    });
                }catch (e) {
                    this.consoleLog(e);
                }
            },

            openCreditDebitModal(){
                this.openCreditDebitLoading = true;
                Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                Vue.axios.get('simplearticles')
                    .then(response =>{
                        this.consoleLog(response);
                        if(!response.data.success){
                            this.handleErrorCodeMessage(response.data);
                            return;
                        }

                        this.articles = response.data.response.articles;
                        this.showCreditDebitModal = true;
                        eventBus.$emit('onCreditDebitModalOpen', this.sellLines, this.articles);

                    }).catch(error => {
                        this.showSnackBar('Erro ao abrir Notas Debito/Credito', 'error');
                    }).finally(()=>{
                        this.openCreditDebitLoading = false;
                });
            },

            downloadPDF(option){
                if (option === this.DOWNLOAD_ORIGINAL){
                    this.invoicePrintLabel = 'Original';
                    this.downloadingOriginal = true;
                }else if(option === this.DOWNLOAD_2VIA){
                    this.invoicePrintLabel = '2ª via';
                    this.downloading2via = true;
                }
                setTimeout(() => {
                    this.downloadPDFWorker();
                }, 200);
            },

            async downloadPDFWorker() {
                const el = this.$refs.factura;
                // this.loggedUser.group.company.image = "data:image/png;base64,aHR0cHM6Ly90cGMuZ29vZ2xlc3luZGljYXRpb24uY29tL3NpbWdhZC81NDAwMzI3MzAzMDE2ODQ4MjU3Ig==";

                let opt = {
                    margin:       0,
                    filename:     this.getFileName,
                    image:        { type: 'jpeg', quality: 1 },
                    // image:        { type: 'png', quality: 0.99 },
                    // html2canvas:  { dpi: 192, useCORS: true},
                    html2canvas:  { scale: 2 },
                    jsPDF:        { unit: 'in', format: this.isInvoiceA5Format ? 'a5' : 'a4', orientation: 'portrait', },
                    // footer: {
                    //     "height": "28mm",
                    //     "contents": {
                    //         first: 'Cover page',
                    //         1: 'Second page', // Any page number is working. 1-based index
                    //         default: '<span style="color: #444;">{{page}}</span>/<span>{{pages}}</span>', // fallback value
                    //         last: 'Last Page'
                    //     }},
                    pdfCallback: this.pdfCallback()
                };

                let pdf = html2pdf().from(el).set(opt);
                pdf.save();

                // this.toDataUrl(this.loggedUser.group.company.image, function(myBase64) {
                //     console.log(myBase64); // myBase64 is the base64 string
                //     this.loggedUser.group.company.image = myBase64;
                //     let pdf = html2pdf().from(el).set(opt);
                //     pdf.save();
                // });

            },

            toDataUrl(url, callback) {
                let xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    var reader = new FileReader();
                    reader.onloadend = function() {
                        callback(reader.result);
                    };
                    reader.readAsDataURL(xhr.response);
                };
                xhr.open('GET', url);
                xhr.responseType = 'blob';
                xhr.send();
            },

            pdfCallback(){
                this.downloadingOriginal = false;
                this.downloading2via = false;
            },
            
            shelve() {
                try{
                    this.shelving = true;
                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.put('invoice/shelve/'+this.selectedInvoice.id, {
                        id: this.selectedInvoice.id,
                        name: this.selectedInvoice.code,
                    }).then(response =>{
                        let str = !this.selectedInvoice.shelved ? 'arquivado' : 'desarquivado';
                        if(!response.data.success){
                            this.handleErrorCodeMessage(response.data);
                            return;
                        }
                        this.selectedInvoice.shelved = response.data.response.invoice.shelved;
                        str = this.selectedInvoice.shelved ? 'arquivado' : 'desarquivado';
                        this.showSnackBar('Fatura '+this.selectedInvoice.code+'/'+this.selectedInvoice.series+' '+str+' com sucesso', 'success');
                        eventBus.$emit('onShelveUnshelve', true, this.selectedInvoice);

                    }).catch(error => {
                        this.consoleLog(error);
                    }).finally(()=>{
                        this.shelving = false;
                    });
                }catch (e) {
                    //Do nothing for now
                }
            },

            sendEmail(){
                try{
                    this.sendingMail = true;
                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.post('invoice/sendmail', {
                        title: 'Nha titulo',
                        to_name: this.fetchedInvoice.sell.client.name,
                        to_email: this.getClientEmail,
                    }).then(response =>{
                        this.consoleLog(response);
                        if(!response.data.success){
                            this.showSnackBar('Erro no envio do email.', 'error');
                            return;
                        }
                        this.showSnackBar('Email enviado', 'success');

                    }).catch(error => {
                        this.consoleLog(error);
                        this.showSnackBar('Erro no envio do email.', 'error');
                    }).finally(()=>{
                        this.sendingMail = false;
                    });
                }catch (e) {
                    //Do nothing for now
                }
            }

        }
    }
</script>